import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Button } from '@factorialco/f0-react'
import { Sort } from '@factorialco/f0-react/icons/app'

import PopoverMenu from 'modules/core/components/PopoverMenu'
import i18n from 'modules/core/lib/i18n'
import useLocalStorage from 'modules/core/lib/useLocalStorage'
import { LOCAL_STORAGE_KEYS } from 'config/Vars'

import { useOrderEmployees } from 'modules/shift_management/hooks/useOrderEmployees'

const SORT_OPTIONS = {
  firstName: 'first_name',
  lastName: 'last_name',
  seniority: 'seniority',
  job: 'job',
} as const

const SORT_DIRECTIONS = {
  asc: 'asc',
  desc: 'desc',
} as const

const SortEmployeesButton = () => {
  const [, setLocalStorageOrderBy] = useLocalStorage<string>(
    LOCAL_STORAGE_KEYS.orderEmployeesShiftManagementBy,
    ''
  )
  const [, setLocalStorageOrderDir] = useLocalStorage<string>(
    LOCAL_STORAGE_KEYS.orderEmployeesShiftManagementDir,
    ''
  )
  const { onOrderEmployees } = useOrderEmployees()

  const onClickMenu = (e: MouseEvent) => {
    e.stopPropagation()
  }

  const refreshInfoShiftsRows = (orderBy: string, orderDir: string) => {
    setLocalStorageOrderBy(orderBy)
    setLocalStorageOrderDir(orderDir)
    onOrderEmployees(orderBy, orderDir)
  }

  const orderOptions = [
    {
      label: i18n.t('shift_management.actions.sort_employees.order_by_first_name_asc'),
      action: () => refreshInfoShiftsRows(SORT_OPTIONS.firstName, SORT_DIRECTIONS.asc),
    },
    {
      label: i18n.t('shift_management.actions.sort_employees.order_by_first_name_desc'),
      action: () => refreshInfoShiftsRows(SORT_OPTIONS.firstName, SORT_DIRECTIONS.desc),
    },
    {
      label: i18n.t('shift_management.actions.sort_employees.order_by_last_name_asc'),
      action: () => refreshInfoShiftsRows(SORT_OPTIONS.lastName, SORT_DIRECTIONS.asc),
    },
    {
      label: i18n.t('shift_management.actions.sort_employees.order_by_last_name_desc'),
      action: () => refreshInfoShiftsRows(SORT_OPTIONS.lastName, SORT_DIRECTIONS.desc),
    },
    {
      label: i18n.t('shift_management.actions.sort_employees.order_by_seniority_asc'),
      action: () => refreshInfoShiftsRows(SORT_OPTIONS.seniority, SORT_DIRECTIONS.asc),
    },
    {
      label: i18n.t('shift_management.actions.sort_employees.order_by_seniority_desc'),
      action: () => refreshInfoShiftsRows(SORT_OPTIONS.seniority, SORT_DIRECTIONS.desc),
    },
    {
      label: i18n.t('shift_management.actions.sort_employees.order_by_job_position_asc'),
      action: () => refreshInfoShiftsRows(SORT_OPTIONS.job, SORT_DIRECTIONS.asc),
    },
    {
      label: i18n.t('shift_management.actions.sort_employees.order_by_job_position_desc'),
      action: () => refreshInfoShiftsRows(SORT_OPTIONS.job, SORT_DIRECTIONS.desc),
    },
  ]

  return (
    <Box flexDirection="row" width="full" alignItems="center" gap="s0">
      <Box flexDirection="row" width="full">
        <Text size="200" weight="medium" className="text-f1-foreground-secondary">
          {i18n.t('common.employees')}
        </Text>
      </Box>

      <Box flexDirection="row" justifyContent="flexEnd" onClick={(event) => onClickMenu(event)}>
        <PopoverMenu type="list">
          <PopoverMenu.Trigger>
            <Box width="full" alignItems="flexEnd" paddingY="s2" onClick={onClickMenu}>
              <F0Button
                hideLabel
                variant="ghost"
                size="sm"
                icon={Sort}
                label={i18n.t('shift_management.actions.sort')}
              />
            </Box>
          </PopoverMenu.Trigger>
          <PopoverMenu.Content side="bottom" align="end" width="s200">
            {orderOptions.map(({ label, action }) => (
              <PopoverMenu.TouchableOption key={label} onClick={action} title={label} />
            ))}
          </PopoverMenu.Content>
        </PopoverMenu>
      </Box>
    </Box>
  )
}

export default SortEmployeesButton
